import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import LabelsSelect from './LabelsSelect'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const LabelsSection = ({ formik, description }) => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()

  return (
    <section className={drawerFormClasses.section}>
      <h4 className={drawerFormClasses.sectionTitle}>{t('Labels')}</h4>
      <p>{description}</p>
      <FieldLabelWrapper label={t('Label')}>
        <LabelsSelect formik={formik} />
      </FieldLabelWrapper>
    </section>
  )
}

LabelsSection.propTypes = {
  description: PropTypes.string
}

export default LabelsSection
